import { Slide, type ToastContentProps, toast } from 'react-toastify';
import styles from './notification.module.css';

export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

interface NotificationMessageProps extends Partial<ToastContentProps> {
  message: string;
  requestId?: string;
  type: NOTIFICATION_TYPE;
}

type NOTIFICATION_TYPE = (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES];

const NotificationMessage = ({ message, type, requestId }: NotificationMessageProps) => (
  <div className={`${styles.message} ${styles[type]}`}>
    <p className={styles.messageFirstLine}>{message}</p>
    {requestId && <p className={styles.messageAdditionalInfo}>Request ID: {requestId}</p>}
  </div>
);

export const showNotification = ({
  message,
  type,
  requestId,
}: { message: string; type: NOTIFICATION_TYPE; requestId?: string }) => {
  toast(<NotificationMessage message={message} requestId={requestId} type={type} />, {
    closeButton: false,
    hideProgressBar: true,
    position: 'bottom-right',
    autoClose: 4000,
    className: styles.notificationWrapper,
    transition: Slide,
  });
};
